import './sentry';
import { main } from "./main/index";

main();